// Old practice in importing components
// import Navbar from 'react-bootstrap/NavBar';
// import Nav from 'react-bootstrap/Nav';
//
//import { useState } from 'react' 
import { useContext } from 'react' 
// New practice in importing components;
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import UserContext from '../UserContext';
import ShopLogo from '../icons/shoplogo.png'


export default function AppNavbar() {
	
	//useContext hook
	const {user} = useContext(UserContext);
	//getItem retrieves the data stored in the localStorage
	// const [user, setUser] = useState(localStorage.getItem("email"))
	 console.log(user);

	return (
			// bg="dark"
		<Navbar className="bkg-main" variant='dark'  expand="lg">
		    <Container fluid>
		      <Navbar.Brand className="text-light" as={Link} to='/'><img src = {ShopLogo}
		height="45px"
		alt = ""
		/>
</Navbar.Brand>

			
				
		      <Navbar.Toggle  aria-controls="navbarScroll" />
		      <Navbar.Collapse   id="navbarScroll">
		        <Nav className="ml-auto" fill>
				{ (user.id !== null && user.isAdmin === false)
				  	? 
					<>
				<Nav.Link className=" text-light" as={Link} to='/'>Home</Nav.Link> 
					 <Nav.Link className="text-light" as={Link} to="/myOrders" >My Orders</Nav.Link> 
					 </>
					:
					<Nav.Link className="text-light" as={Link} to='/'>Home</Nav.Link>
				  }
		          
		          {/* <Nav.Link as={Link} to='/product'>Products</Nav.Link> */}
				  {
		          	(user.isAdmin)
		          	?
		          	<Nav.Link className="text-light" as={Link} to="/admin" >Admin Dashboard</Nav.Link>
		          	:
				
		          	
					  <Nav.Link className="text-light" as={Link} to='/product'>Products</Nav.Link>
				
		          }
				

				  
				  {/* email to user.id s55 */}
				  { (user.id !== null) ? 
				 	 	<Nav.Link  className="text-light" as={Link} to='/logout'>Logout</Nav.Link>

					:
					<>
						<Nav.Link  className="text-light" as={Link} to='/register'>Register</Nav.Link>
						<Nav.Link className="text-light" as={Link} to='/login'>Login</Nav.Link>
					</>
				  }
				
				  	
		        </Nav>
		      </Navbar.Collapse>
			  </Container>
			 
		   
		  </Navbar>
	)
};